import { render, staticRenderFns } from "./EditPeriod.vue?vue&type=template&id=89f7e2b0&scoped=true"
import script from "./EditPeriod.vue?vue&type=script&lang=js"
export * from "./EditPeriod.vue?vue&type=script&lang=js"
import style0 from "./EditPeriod.vue?vue&type=style&index=0&id=89f7e2b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f7e2b0",
  null
  
)

export default component.exports